import { ApplicationState, NEiTThunk } from '..';
import { BeginAjaxCallAction, EndAjaxCallAction } from '../core/actionTypes';
import notification from '../notification';
import { ContributiActions } from './actionTypes';
import * as contributiApi from './api';

type Actions = 
    ContributiActions |
    BeginAjaxCallAction |
    EndAjaxCallAction;

export const requestContributiInScadenza= (): NEiTThunk<void, Actions> => (dispatch, getState) =>  {
    dispatch({ type: 'core/BEGIN_AJAX_CALL' });

    const state: ApplicationState = getState();
    const refreshCache: boolean = false;

    contributiApi.getContributiInScadenza(state, refreshCache)
        .then(inScadenza => {

            console.log(inScadenza);

            dispatch({ type: 'contributi/REQUEST_CONTRIBUTI_SCADENZE', value: inScadenza });
            dispatch({ type: 'core/END_AJAX_CALL' });
        })
        .catch(error => {
            dispatch({ type: 'core/END_AJAX_CALL' });
            notification.error(error.message);
        });
}